module.exports = __webpack_public_path__ + "static/media/homepage2.fbe2b54e.png";